import { Directive, Input, ElementRef, HostListener, OnDestroy, DoCheck } from "@angular/core"
import { TooltipService } from "@shared/services/tooltip.service"
import { AdjustPosition, Position } from "./ag-tooltip-v2.component"

@Directive({
    selector: "[agTooltipV2]",
    standalone: false
})
export class AgTooltipDirectiveV2 implements OnDestroy, DoCheck {
  @Input() agTooltipTitle = ""
  @Input() agTooltipBody = ""
  @Input() agTooltipPos: Position = "right"
  @Input() agTooltipAdjust: AdjustPosition = { position: "top", space: 0 }
  @Input("agTooltipCondition") condition = true

  private id: number
  private tooltipActive = false
  private lastTitle = ""
  private lastBody = ""
  private timeoutId: any = null

  constructor(private tooltipService: TooltipService, private element: ElementRef) {}

  @HostListener("mouseenter")
  onMouseEnter(): void {
    if (this.condition) {
      this.timeoutId = setTimeout(() => {
        this.push()
        this.tooltipActive = true
        this.timeoutId = null
      }, 500)
    }
  }

  @HostListener("mouseleave")
  onMouseLeave(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
    this.destroy()
  }

  ngOnDestroy(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
    this.destroy()
  }

  destroy(): void {
    const idx = this.tooltipService.componentsV2.findIndex((t) => t.id === this.id)

    if (idx !== -1) {
      this.tooltipService.componentsV2.splice(idx, 1)
    }
    this.tooltipActive = false
  }

  push() {
    this.id = Math.random()
    this.lastTitle = this.agTooltipTitle
    this.lastBody = this.agTooltipBody
    this.tooltipService.componentsV2.push({
      id: this.id,
      ref: this.element,
      title: this.agTooltipTitle,
      description: this.agTooltipBody,
      position: this.agTooltipPos,
      adjustPosition: this.agTooltipAdjust,
    })
  }

  ngDoCheck(): void {
    if (this.tooltipActive && (this.agTooltipTitle !== this.lastTitle || this.agTooltipBody !== this.lastBody)) {
      this.updateTooltip()
    }
  }

  private updateTooltip(): void {
    const tooltip = this.tooltipService.componentsV2.find((t) => t.id === this.id)
    if (tooltip) {
      tooltip.title = this.agTooltipTitle
      tooltip.description = this.agTooltipBody
    }
    this.lastTitle = this.agTooltipTitle
    this.lastBody = this.agTooltipBody
  }
}
